<template>
  <v-container>
    <v-layout row wrap>
      <v-flex>
        <info-table
          :roleLinkField="roleLinkField"
          :roleLinkParam="roleLinkParam"
          :profile="profile"
          :updatePermissions="['PROFILE.UPDATE', 'PARTNER.EMPLOYEE_UPDATE']"
          @showEditModal="showEditModal"
        ></info-table>
      </v-flex>
    </v-layout>

    <modal :show="showModal" :id="editId" :edit="!!editId" @close="hideModal" @update="update"></modal>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { isOfficial } from '@witkac/kartamiejska-shared';

import InfoTable from '@/views/profile/InfoTable';
import store from '@/store/store';
import { modalMixin } from '@/mixins/modal';
import Modal from './modals/Employee.modal';

/**
 * @vuese
 * Profil
 * @group employees
 */
export default {
  components: {
    InfoTable,
    Modal
  },
  mixins: [
    modalMixin('employees', {
      getError: 'Wystąpił błąd podczas pobierania danych pracownika.',
      updated: 'Zaktualizowano dane pracownika.',
      updateError: 'Nie udało się zaktualizować danych pracownika.'
    })
  ],
  async beforeRouteUpdate(to, from, next) {
    try {
      store.commit('employees/setId', to.params.employeeId);

      await store.dispatch('employees/get');
      next();
    } catch (error) {
      store.dispatch('notifyError', { title: 'Nie udało się pobrać danych pracownika' });
    }
  },

  computed: {
    ...mapState({
      profile: state => state.employees.data.profile,
      editId: state => state.employees.data.profile.id.toString()
    }),
    roleLinkField() {
      return isOfficial() ? 'employeeOfficialRoles' : 'employeePartnerRoles';
    },
    roleLinkParam() {
      return isOfficial() ? 'employeeId' : 'id';
    }
  }
};
</script>
